/** Shared non-legacy product data: account credits, bonuses, and top-up packs. */
import { VERIFIED_SIGNUP_CREDITS } from '../lib/credits';
import type { CreditPack, Product } from '../types/domain';
import { CURRENT_PRODUCTS } from './upgradeOffers';

function currentProduct(id: Product['id']): Product {
  const product = CURRENT_PRODUCTS.find((candidate) => candidate.id === id);
  if (!product) throw new Error(`Missing current product definition for "${id}".`);
  return product;
}

export const FRONTEND_PRODUCT: Product = {
  ...currentProduct('frontend'),
  credits: VERIFIED_SIGNUP_CREDITS,
};

/** Kept as a domain name for licence screens; its data comes from the current add-on. */
export const COMMERCIAL_ADDON: Product = currentProduct('commercial-certification');

export const STANDARD_CREDIT_PRICE_USD = 0.5;
export const BULK_CREDIT_FLOOR_USD = 0.4;

function creditPack(
  id: string,
  credits: number,
  price: number,
  options: Pick<CreditPack, 'best'> = {}
): CreditPack {
  const perCredit = price / credits;
  if (perCredit + Number.EPSILON < BULK_CREDIT_FLOOR_USD) {
    throw new Error(
      `Credit pack "${id}" is priced at $${perCredit.toFixed(2)} per credit, below the $${BULK_CREDIT_FLOOR_USD.toFixed(2)} floor.`
    );
  }

  return { id, credits, price, per: perCredit.toFixed(2), ...options };
}

/**
 * Top-up bundles offered in Settings and the out-of-credits dialog.
 * Small packs begin at the $0.50 standard rate and volume discounts stop at $0.40.
 */
export const PACKS: CreditPack[] = [
  creditPack('p50', 50, 25),
  creditPack('p200', 200, 94),
  creditPack('p1000', 1_000, 400, { best: true }),
];
